import { render, staticRenderFns } from "./userFbsrule.vue?vue&type=template&id=914ee60e&scoped=true&"
import script from "./userFbsrule.vue?vue&type=script&lang=js&"
export * from "./userFbsrule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "914ee60e",
  null
  
)

export default component.exports